import constant from "../../constant";
import axios from "axios";
import router from "../../router";
import { printData } from "../../utils/printUtils";
const api = constant.api + "payments";
const supplierApi = constant.api + "payments_suppliers";
// initial state
const state = () => ({
  all: [],
  payments: [],
  payment: {},
});

// getters
const getters = {
  getAll: (state) => {
    return state.all;
  },
  getPayment: (state) => {
    return state.payment;
  },

  getPayments: (state) => {
    return state.payments;
  },

  getTotalAmount: (state) =>
    state.payments.reduce((acc, val) => acc + parseFloat(val.amount), 0),
};

// actions
const actions = {
  async getAll({ commit }) {
    try {
      const payments = await this.$api.fetch(api);
      commit("SET_PAYMENTS", Array.isArray(payments) ? payments : []);
    } catch (error) {
      console.error("Error fetching payments:", error);
      commit("SET_PAYMENTS", []);
    }
  },

  async show({ commit }, reference) {
    try {
      const response = await this.$api.show(api + "/" + reference);
      const payment = response.data || response || {};
      commit("setPayment", payment);
    } catch (error) {
      console.error("Error fetching payment:", error);
    }
  },

  async store({ dispatch }, data) {
    try {
      const response = await this.$api.create(api, data);
      let status = response.data.status;

      if (status == "success") {
        router.push({ name: "payments-customers-index" });
      }
    } catch (error) {
      console.error("Error creating payment:", error);
    }
  },

  async update({ dispatch }, data) {
    try {
      const response = await this.$api.update(api + "/" + data.reference, data, { confirm: false });
      let message = response.data.message;
      let status = response.data.status;

      dispatch("notification/store", { status, message }, { root: true });

      if (status == "success") {
        router.push({
          name: "payments-customers-index",
        });
      }
    } catch (error) {
      console.error("Error updating payment:", error);
    }
  },

  async destroy({ dispatch }, reference) {
    try {
      const response = await this.$api.delete(api + "/" + reference, { confirm: false });
      let status = response.data.status;

      if (status == "success") {
        router.push({ name: "payments-customers-index" });
      }
    } catch (error) {
      console.error("Error deleting payment:", error);
    }
  },

  async filter({ dispatch, commit }, data) {
    try {
      const response = await this.$api.create(api + "_filter", data, { confirm: false });
      let payments = response.data;
      commit("SET_PAYMENTS", payments);
    } catch (error) {
      console.error("Error filtering payments:", error);
    }
  },

  async print({ dispatch }, data) {
    try {
      dispatch(
        "notification/storeDownloading",
        {
          status: "success",
          message:
            "La liste des paiements du client est en cours de téléchargement. Veuillez patienter...",
        },
        { root: true }
      );
      await printData(data, api + "_print", "POST");
    } catch (error) {
      console.error(error);
    }
  },

  async printReceipt({ dispatch }, reference) {
    try {
      dispatch(
        "notification/storeDownloading",
        {
          status: "success",
          message:
            "Votre reçu de paiement est en cours de téléchargement, veuillez patienter...",
        },
        { root: true }
      );
      const response = await axios
        .get(api + "_print_receipt/" + reference, {
          responseType: "blob", // Set the response type to 'blob' to handle binary data
        })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "Recu.pdf");
          link.click();
        })
        .catch((error) => {
          console.error(error);
        });
    } catch (error) {
      console.error(error);
    }
  },

  async fetchPaymentSupplier({ commit }) {
    try {
      const payments = await this.$api.fetch(supplierApi);
      commit("SET_PAYMENTS", Array.isArray(payments) ? payments : []);
    } catch (error) {
      console.error("Error fetching supplier payments:", error);
      commit("SET_PAYMENTS", []);
    }
  },

  async showPaymentSupplier({ commit }, reference) {
    try {
      const response = await this.$api.show(supplierApi + "/" + reference);
      const payment = response.data || response || {};
      commit("setPayment", payment);
    } catch (error) {
      console.error("Error fetching supplier payment:", error);
    }
  },

  async storePaymentSupplier({ dispatch }, data) {
    try {
      const response = await this.$api.create(supplierApi, data, { confirm: false });
      let message = response.data.message;
      let status = response.data.status;

      dispatch("notification/store", { status, message }, { root: true });

      if (status == "success") {
        router.push({
          name: "payments-suppliers-index",
        });
      }
    } catch (error) {
      console.error("Error storing supplier payment:", error);
    }
  },

  async updatePaymentSupplier({ dispatch }, data) {
    try {
      const response = await this.$api.update(supplierApi + "/" + data.reference, data, { confirm: false });
      let message = response.data.message;
      let status = response.data.status;

      dispatch("notification/store", { status, message }, { root: true });

      if (status == "success") {
        router.push({
          name: "payments-suppliers-index",
        });
      }
    } catch (error) {
      console.error("Error updating supplier payment:", error);
    }
  },

  async destroyPaymentSupplier({ dispatch }, reference) {
    try {
      const response = await this.$api.delete(supplierApi + "/" + reference, { confirm: false });
      let status = response.data.status;

      if (status == "success") {
        router.push({ name: "payments-suppliers-index" });
      }
    } catch (error) {
      console.error("Error deleting supplier payment:", error);
    }
  },

  async filterPaymentSupplier({ commit }, data) {
    try {
      const response = await this.$api.create(supplierApi + "_filter", data, { confirm: false });
      commit("SET_PAYMENTS", response.data);
    } catch (error) {
      console.error("Error filtering supplier payments:", error);
    }
  },

  async printPaymentSupplier({ dispatch }, data) {
    try {
      dispatch(
        "notification/storeDownloading",
        {
          status: "success",
          message:
            "La liste des paiements du fournisseur est en cours de telechargement. Veuillez patienter...",
        },
        { root: true }
      );
      await printData(data, supplierApi + "_print", "POST");
    } catch (error) {
      console.error(error);
    }
  },

  async printSupplierReceipt({ dispatch }, reference) {
    try {
      dispatch(
        "notification/storeDownloading",
        {
          status: "success",
          message:
            "Votre recu de paiement fournisseur est en cours de telechargement, veuillez patienter...",
        },
        { root: true }
      );
      await axios
        .get(supplierApi + "_print_receipt/" + reference, {
          responseType: "blob",
        })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "Recu-fournisseur.pdf");
          link.click();
        })
        .catch((error) => {
          console.error(error);
        });
    } catch (error) {
      console.error(error);
    }
  },
};

// mutations
const mutations = {
  SET_PAYMENTS(state, payments) {
    state.all = payments;
    state.payments = payments;
  },
  setPayment(state, payment) {
    state.payment = payment;
  },
  async search(state, value) {
    value = value.charAt(0).toUpperCase() + value.slice(1);
    console.log(value);
    state.payments = state.all.filter(function (payment) {
      return (
        payment.firstName.toUpperCase().indexOf(value.toUpperCase()) > -1 ||
        payment.lastName.toUpperCase().indexOf(value.toUpperCase()) > -1 ||
        payment.phone.toUpperCase().indexOf(value.toUpperCase()) > -1 ||
        payment.reference.toUpperCase().indexOf(value.toUpperCase()) > -1
      );
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
